import { render, staticRenderFns } from "./TaskNumberCard.vue?vue&type=template&id=7823b9b0"
import script from "./TaskNumberCard.vue?vue&type=script&lang=js"
export * from "./TaskNumberCard.vue?vue&type=script&lang=js"
import style0 from "./TaskNumberCard.vue?vue&type=style&index=0&id=7823b9b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports